import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Image from '../../elements/Image';
import Button from '../../elements/Button';

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 1
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1
    }
};

const CarouselNew = () => {
    return (
        <Carousel
            swipeable={false}
            draggable={false}
            showDots={true}
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            infinite={true}
            // autoPlay={this.props.deviceType !== "mobile" ? true : false}
            autoPlaySpeed={100000000}
            keyBoardControl={true}
            customTransition="all .5"
            transitionDuration={500}
            containerClass="carousel-container"
            removeArrowOnDeviceType={["tablet", "mobile"]}
            // deviceType={this.props.deviceType}
            dotListClass="custom-dot-list-style"
            itemClass="carousel-item-padding-40-px"
        >
            <div className="split-item item-proyectos">
                <div className="col-12 col-md-6 p-2">
                    <h3 className="mt-0 mb-12 title-proyectos">
                        Plan General de Ordenación Forestal
                    </h3>
                    <p className="m-0 p-proyectos">
                        Estudio elaborado por la CDMB el cual describe los aspectos bióticos, abióticos, sociales y económicos,
                        con la finalidad de asegurar que el interesado en utilizar el recurso en un área forestal productora,
                        desarrolle su actividad en forma planificada para así garantizar el manejo adecuado y el aprovechamiento
                        sostenible del recurso (Minambiente).
                    </p>
                    <Button className="fw-normal button-viewer-geo"
                        tag="a" target="_blank" color="primary"
                        wideMobile href="/visor?info=PlanGeneralOrdenacionForestal">Ver</Button>
                </div>
                <div className="col-12 col-md-6 p-2">
                    <Image
                        src={require('./../../../assets/images/estudios/Ordenamiento_Forestal.jpg')}
                        alt="Features split 01"
                        height={396} />
                </div>
            </div>
            <div className="split-item">
                <div className="col-12 col-md-6 p-2">
                    <h3 className="mt-0 mb-12 title-proyectos">
                        Plan de Ordenación y Manejo de Cuencas Hidrográficas
                    </h3>
                    <p className="m-0 p-proyectos">
                        Es el instrumento a través del cual se realiza la planeación del uso coordinado del suelo,
                        de las aguas, de la flora y la fauna y el manejo de la cuenca entendido como la ejecución de
                        obras y tratamientos, en la perspectiva de mantener el equilibrio entre el aprovechamiento
                        social y económico de tales recursos y la conservación de la estructura físico-biótica de la
                        cuenca y particularmente del recurso hídrico. Para la CDMB se encuentran los planes para la
                        cuenca del río Suratá y río Lebrija Alto.
                    </p>
                    <Button className="fw-normal button-viewer-geo"
                        tag="a" target="_blank" color="primary"
                        wideMobile href="/visor?info=PlanOrdenacionManejoCuencaHidrografica">Ver</Button>
                </div>
                <div className="col-12 col-md-6 p-2">
                    <Image
                        src={require('./../../../assets/images/estudios/Cuencas_Hidrograficas.jpg')}
                        alt="Features split 02"
                        height={396} />
                </div>
            </div>

            <div className="split-item">
                <div className="col-12 col-md-6 p-2">
                    <h3 className="mt-0 mb-12 title-proyectos">
                        Planes de Ordenamiento Territorial Municipal
                    </h3>
                    <p className="m-0 p-proyectos">
                        Es el instrumento básico definido en la Ley 388 de 1997, para que los municipios y distritos del país
                        planifiquen el ordenamiento del territorio a escala detallada. Esta información debe establecerse por
                        cada municipio y el presente acceso permite la información cartográfica de zonificación, asociada a los
                        principales municipios de la jurisdicción de la corporación CDMB.
                    </p>
                    <Button className="fw-normal button-viewer-geo"
                        tag="a" target="_blank" color="primary"
                        wideMobile href="/visor?info=PlanesOrdenamientoTerritorial">Ver</Button>
                </div>
                <div className="col-12 col-md-6 p-2">
                    <Image
                        src={require('./../../../assets/images/estudios/Ordenamiento_Territorial.jpg')}
                        alt="Features split 03"
                        height={396} />
                </div>
            </div>

            <div className="split-item">
                <div className="col-12 col-md-6 p-2">
                    <h3 className="mt-0 mb-12 title-proyectos">
                        Plan de Ordenamiento Departamental
                    </h3>
                    <p className="m-0 p-proyectos">
                        Es el instrumento a través del cual se realiza la planeación del uso coordinado del suelo, de las aguas,
                        de la flora y la fauna y el manejo de la cuenca entendido como la ejecución de obras y tratamientos, en la
                        perspectiva de mantener el equilibrio entre el aprovechamiento social y económico de tales recursos y la
                        conservación de la estructura físico-biótica de la cuenca y particularmente del recurso hídrico. Para la
                        CDMB se encuentran los planes para la cuenca del río Suratá y río Lebrija Alto.
                    </p>
                    <Button className="fw-normal button-viewer-geo"
                        tag="a" target="_blank" color="primary"
                        wideMobile href="/visor?info=PlanesOrdenamientoDepartamental">Ver</Button>
                </div>
                <div className="col-12 col-md-6 p-2">
                    <Image
                        src={require('./../../../assets/images/estudios/Ordenamiento_Departamental.jpg')}
                        alt="Features split 02"
                        height={396} />
                </div>
            </div>

            {/* <div className="split-item">
              <div className="col-12 col-md-6 reveal-from-left">
                <h3 className="mt-0 mb-12 title-proyectos">
                  Permisos, Concesiones, Vertimientos, aprovechamientos y Ocupación
                </h3>
                <p className="m-0 p-proyectos">
                  Resumen corto del contenido del estudio y/o proyecto ambiental. Resumen corto del contenido del estudio 
                  y/o proyecto ambiental. Resumen corto del contenido del estudio y/o proyecto ambiental. Resumen corto del
                  contenido del estudio y/o proyecto ambiental.
                </p>
              </div>
              <div className={
                classNames(
                  'split-item-image reveal-from-bottom',
                  'split-item-image-fill'
                )}>
                <Image
                  src={require('./../../../assets/images/estudios/Tramites.jpg')}
                  alt="Features split 03"
                  height={396} />
              </div>
            </div> */}
        </Carousel>
    );
}

export default CarouselNew;